import {
  DotFillIcon,
  DotIcon,
  KebabHorizontalIcon,
  PencilIcon,
  PlusIcon,
  SyncIcon,
  TrashIcon,
  UploadIcon,
} from "@primer/octicons-react";
import {
  ActionList,
  ActionMenu,
  Avatar,
  Box,
  Checkbox,
  useConfirm,
} from "@primer/react";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../components/ui/button";
import DataTable from "../../../components/ui/data-table";
import { useCommonSelectedHook } from "../../../hooks/useCommonSelectedHook";
import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { actions } from "../../../state/actions/actionsWrapper";

import Text from "../../../components/ui/text";
import { useCommonContext } from "../../../contexts/common";
import { RootState } from "../../../state/reducers";
import { IFoCaAn } from "../../../models/response/thuc-don/IFoCaAn";
import UserAvatar from "../../../components/user-avatar";
import { IFoMonAnChiTiet } from "../../../models/response/thuc-don/IFoMonAnChiTiet";
import DangKyMonAnEditModal from "./DangKyMonAnEditModal";
import MonAnImport from "./import-monan";

const DangKyMonAnPage = () => {
  const { status, foMonAnChiTiets, isShowEditModal, editingData } = useSelector(
    (x: RootState) => x.thucDonWrapper.monAnChiTiet
  );
  const { nam_hoc, dm_coso_id } = useCommonSelectedHook();
  const { translate } = useCommonContext();
  const confirm = useConfirm();
  const dispatch = useDispatch();
  const [showImportThucDon, setShowImportThucDon] = useState<boolean>(false)

  useEffect(() => {
    if (
      status === ePageBaseStatus.is_not_initialization ||
      status === ePageBaseStatus.is_need_reload
    ) {
      handleReload();
    }
  }, [status, nam_hoc, dm_coso_id]);
  const handleReload = () => {
    dispatch(actions.thucDonWrapper.monAnChiTiet.LOAD_START(undefined));
  };
  const handleDelete = async (id: number) => {
    if (
      await confirm({
        content: translate("Base.Label.DeleteConfirm.Content"),
        title: translate("Base.Label.Confirm"),
        cancelButtonContent: translate("Base.Label.Close"),
        confirmButtonContent: translate("Base.Label.Delete"),
        confirmButtonType: "danger",
      })
    ) {
      dispatch(actions.thucDonWrapper.monAnChiTiet.DELETE_START(id));
    }
  };
  const handleBtnImportClicked = () => {
    setShowImportThucDon(true);
  };
  const handleCloseDetailModal = useCallback(() => {
    setShowImportThucDon(false);
  }, []);
  return (
    <Box
      sx={{
        p: 3,
      }}
    >
      <DataTable
        height={`${window.innerHeight - 260}px`}
        data={foMonAnChiTiets || []}
        isLoading={status === ePageBaseStatus.is_loading}
        title={"Danh sách món ăn"}
        searchEnable
        paging={{ enable: true }}
        actionComponent={
          <Box
            sx={{
              display: "flex",
              gap:2
            }}
          >

            <Button
              text="Base.Label.Refresh"
              leadingVisual={SyncIcon}
              size="medium"
              sx={{ ml: 1 }}
              onClick={() => {
                handleReload();
              }}
            />
            <Button
              text="Base.Label.AddNew"
              leadingVisual={PlusIcon}
              size="medium"
              variant="primary"
              onClick={() => {
                dispatch(
                  actions.thucDonWrapper.monAnChiTiet.SHOW_EDIT_MODAL(undefined)
                );
              }}
            />
            <Button
              text="Base.Label.Import"
              leadingVisual={UploadIcon}
              size="medium"
              onClick={handleBtnImportClicked}
            />
          </Box>
        }
        columns={[
          {
            dataField: "ten_mon_an",
            caption: translate("Tên món ăn (Vi)"),
            cellRender: (data) => (
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box
                  sx={{
                    display: "inline-flex",
                    verticalAlign: "sub",
                    lineHeight: 1,
                    mr: 1,
                  }}
                >
                  <div style={{ color: "#62825D" }}>
                    <DotFillIcon size={14} />{" "}
                  </div>
                </Box>

                <span style={{ fontWeight: "500" }}>{data.ten_mon_an}</span>
              </Box>
            ),
          },

          {
            dataField: "ten_mon_an_en",
            caption: translate("Tên món ăn (En)"),
          },
          {
            dataField: "calo",
            caption: translate("Calo"),
            align: "center",
          },
          {
            dataField: "idx_order",
            caption: translate("Thứ tự hiển thị"),
            align: "center",
          },
          //   {
          //     dataField: "idx_order",
          //     caption: translate("monan.Order"),
          //   },

          {
            id: "cmd",
            caption: "",
            width: "50px",
            align: "center",
            cellRender: (data: IFoMonAnChiTiet) => {
              return (
                <ActionMenu>
                  <ActionMenu.Button
                    icon={KebabHorizontalIcon}
                    variant="invisible"
                    sx={{ m: -1 }}
                  >
                    &nbsp;
                  </ActionMenu.Button>
                  <ActionMenu.Overlay width="auto">
                    <ActionList>
                      <ActionList.Item
                        onSelect={() => {
                          dispatch(
                            actions.thucDonWrapper.monAnChiTiet.SHOW_EDIT_MODAL(
                              data
                            )
                          );
                        }}
                      >
                        <ActionList.LeadingVisual>
                          <PencilIcon />
                        </ActionList.LeadingVisual>
                        <Text text="Base.Label.Edit" />
                      </ActionList.Item>
                      <ActionList.Item
                        variant="danger"
                        onSelect={() => {
                          handleDelete(data.id);
                        }}
                      >
                        <ActionList.LeadingVisual>
                          <TrashIcon />
                        </ActionList.LeadingVisual>
                        <Text text="Base.Label.Delete" />
                      </ActionList.Item>
                    </ActionList>
                  </ActionMenu.Overlay>
                </ActionMenu>
              );
            },
          },
        ]}
      />
      {isShowEditModal && <DangKyMonAnEditModal />}
      {showImportThucDon && (
        <MonAnImport
          onClose={handleCloseDetailModal}
          animationOf={`#btnImport`}
        />
      )}
    </Box>
  );
};

export default DangKyMonAnPage;
